import {createTheme, Theme} from "@mui/material";
import {deDE} from "@mui/material/locale";

// WhatsApp-like green theme mit deutschem Locale
export const theme = createTheme({
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: ({theme}: { theme: Theme }) => ({
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
        })
      }
    }
  },
  colorSchemes: {
    light: {
      palette: {
        mode: 'light',
        primary: {contrastText: 'white', main: '#25D366'},   // WhatsApp-Grün
      },
    },
    dark: {
      palette: {
        mode: 'dark',
        primary: {contrastText: 'white', main: '#25D366'},   // genauso im Dark Mode
      },
    },
  },
}, deDE);